import { QueryClient } from '@tanstack/react-query'

const defaultOptions = {
  queries: {
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    retry: false,
    cacheTime: 1000 * 60 * 60 * 24, // 24 hours
  },
}

export const queryClient = new QueryClient({ defaultOptions })
